import * as React from 'react'
import { cn } from '@/lib/utils'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'ghost' | 'link'
  size?: 'default' | 'sm' | 'lg' | 'icon'
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = 'default', ...props }, ref) => {
    const baseStyles =
      'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50'

    const variants = {
      default: 'bg-terracotta text-white hover:bg-terracotta-dark shadow-sm',
      secondary: 'bg-wood text-cream hover:bg-wood-dark shadow-sm',
      outline:
        'border-2 border-terracotta text-terracotta hover:bg-terracotta hover:text-white',
      ghost: 'hover:bg-cream-dark text-wood',
      link: 'text-terracotta underline-offset-4 hover:underline',
    }

    const sizes = {
      default: 'h-10 px-6 py-2',
      sm: 'h-9 rounded-md px-4',
      lg: 'h-12 rounded-md px-8 text-base',
      icon: 'h-10 w-10',
    }

    return (
      <button
        className={cn(baseStyles, variants[variant], sizes[size], className)}
        ref={ref}
        {...props}
      />
    )
  },
)
Button.displayName = 'Button'

export { Button }
